<template>
    <div class="login">
        <b-modal id="fp-modal" title="Forget Password" size="sm" centered hide-footer @show="resetModal" @hidden="resetModal" @ok="handleOk" no-stacking>
			<form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group :state="userinfoState" label="Mobile or Email" label-for="mobile-input" invalid-feedback="Mobile or Email should be valid">
                    <b-form-input id="mobile-input" v-model="userinfo" :state="userinfoState"></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="primary" class="mr-2">Submit</b-button>
                <b-button type="reset" variant="light" @click="handleCancel()">Cancel</b-button>
			</form>
		</b-modal>
    </div>
</template>

<script>
export default {
    name: 'Quickview',
    data() {
        return{
            userinfo: '',
            userinfoState: null,
        }
    },
    methods:{
        checkFormValidity() {
            var valid = true;
            if(this.userinfo.length < 10){
                valid = false;
                this.userinfoState = false;
            }else{
                this.userinfoState = true;
            }
            return valid;
        },
        resetModal(){
            this.userinfo = '';
            this.userinfoState = null;
        },
        handleOk(bvModalEvt){
            bvModalEvt.preventDefault();
            this.handleSubmit();
        },
        handleCancel(){
            this.$bvModal.hide('fp-modal');
        },
        handleSubmit(){
            if (!this.checkFormValidity()) {
                return;
            }

            this.$bvModal.hide('fp-modal');
        },
        

        showForgetPasswordModal(){
            this.$bvModal.hide('login-modal');
            this.$root.$emit('bv::show::modal', 'fp-modal')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


</style>
